export default Object.freeze({
  STEPS: [
    {
      target: '#v-step-0',
      content: 'この画面では御社用の基本設定が編集ができます。<br>インボイス制度向けの適格事業者番号はこの画面で設定してください。',
      params: {
        enableScrolling: false,
        placement: 'bottom'
      }
    }
  ]
})
